import * as React from "react"
import {
  RadarIcon,
  Settings2,
  SquareTerminal,
  Antenna,
  ChartLine,
  Fence,
  Shield,
  Plane,
  LifeBuoy,
  FileText,
  ShieldCheck,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { PlanIndicator } from "@/components/plan-indicator"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar"
import { useUser } from "@clerk/clerk-react"
import { Link } from "@tanstack/react-router"
import { NavSensors } from "./nav-sensors"
import { Topbar } from "./nav-top"
import { NavGeofences } from "./nav-geofences"


const sidebarItems = [
    {
        title: "Dashboard",
        url: "/",
        icon: SquareTerminal,
    },
    {
        title: "Map",
        url: "/map",
        icon: RadarIcon,
    },
    {
        title: "Geofences",
        url: "/geofences",
        icon: Fence,
    },
    {
        title: "Flight Restrictions",
        url: "/flight-restriction-zones",
        icon: Shield,
    },
    {
        title: "Flight Plans",
        url: "/flight-plans",
        icon: Plane,
    },
    {
        title: "Sensors",
        url: "/sensors",
        icon: Antenna,
    },
    {
        title: "Settings",
        url: "/account",
        icon: Settings2,
        items: [
            {
                title: "Account",
                url: "/account",
            },
            {
                title: "Preferences",
                url: "/preferences",
            },
        ],
    },
    {
        title: "Analytics",
        url: "/analytics",
        icon: ChartLine,
        items: [
            {
                title: "Analytics",
                url: "/analytics",
            },
            {
                title: "Activity Heatmap",
                url: "/analytics/heatmap",
            },
            {
                title: "Detection Replay",
                url: "/analytics/detection-replay",
            },
        ],
    },
];

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const user = useUser()
    const { state } = useSidebar()

    return (
        <Sidebar collapsible="icon" {...props} className="z-10 absolute">
            <SidebarHeader>
                <Topbar />
            </SidebarHeader>
            <SidebarContent>
                <NavMain items={sidebarItems} />
                <NavSensors />
                <NavGeofences />
            </SidebarContent>
            <SidebarFooter>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild size="sm">
                            <Link to="/support">
                                <LifeBuoy />
                                <span>Support</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild size="sm">
                            <Link to="/legal/privacy-policy">
                                <ShieldCheck />
                                <span>Privacy Policy</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild size="sm">
                            <Link to="/legal/terms-of-use">
                                <FileText />
                                <span>Terms of Use</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
                {state === "expanded" && <PlanIndicator />}
                <NavUser user={
                    {
                        name: user.user?.fullName ?? '',
                        avatar: user.user?.imageUrl ?? '',
                        email: user.user?.emailAddresses[0].emailAddress ?? ''
                    }
                } />
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    )
}
